// extracted by mini-css-extract-plugin
export default {"Search-Tray":"SearchTray_Search-Tray__d+XXZ","catchers":"SearchTray_catchers__sX3FR","searchIcon":"SearchTray_searchIcon__kyqdI"};